import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useStore } from 'hooks';
import { VALIDATION } from 'helpers/constants';
import { Button, ButtonClose } from 'components/ui/form';
import { Input } from 'components/ui/formik';
import { DirectionService } from 'services';
import styles from './direction.module.scss';

const Direction = ({ edit, onClose }) => {
  const { setUser, setLoading } = useStore();
  const initialValues = {
    name: edit ? edit.name : '',
    code: edit?.code || '',
  };

  const onSubmit = async (values, { setErrors }) => {
    setLoading(true);
    try {
      const service = new DirectionService({ setUser });
      const response = edit
        ? await service.updateDirection(edit.id, values)
        : await service.createDirection(values);

      if (response?.__httpError) {
        const errors = (response.errors || []).reduce((result, error) => ({
          ...result,
          [error.path]: error.msg,
        }), {});
        setErrors(errors);
      } else if (response) {
        onClose(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={Yup.object().shape({
        name: Yup.string()
          .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
          .required(...VALIDATION.REQUIRED),
        code: Yup.string()
          .trim()
          .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING)),
      })}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={styles.contact} autoComplete="off">
          <div className={styles.main}>
            <div className={styles.title}>
              {edit ? 'Редактирование направления' : 'Добавление направления'}
            </div>
            <div className={styles.fields}>
              <div className={styles.field}>
                <Input label="Название" placeholder="Название направления" name="name" />
              </div>
              <div className={styles.field}>
                <Input label="Код" placeholder="Код" name="code" />
              </div>
            </div>
          </div>
          <div className={styles.buttons}>
            <div>
              <Button type="submit">{edit ? 'Редактировать' : 'Добавить'}</Button>
            </div>
            <div>
              <ButtonClose onClick={() => onClose(false)}>{edit ? 'Закрыть' : 'Отменить'}</ButtonClose>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default Direction;
